import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { HotelsShopSelectors } from "@b2bportal/core-hotels";
import { LodgingSelectionEnum, type Suggestion } from "@b2bportal/lodging-api";
import { fetchLocationByLabelAndId } from "./index";

export const usePlaceFromLodgingSelection = (): Suggestion | undefined => {
  const [place, setPlace] = useState<Suggestion | undefined>(undefined);
  const lodgingSelection = useSelector(HotelsShopSelectors.getLodgingSelection);

  useEffect(() => {
    const fetchPlace = async () => {
      if (!lodgingSelection) {
        setPlace(undefined);
        return;
      }

      // Only handle Place type lodging selection
      if (lodgingSelection.LodgingSelection !== LodgingSelectionEnum.Place) {
        setPlace(undefined);
        return;
      }

      const { searchTerm, placeId } = lodgingSelection;

      if (!searchTerm) {
        setPlace(undefined);
        return;
      }

      try {
        const result = await fetchLocationByLabelAndId(searchTerm, placeId);
        setPlace(result);
      } catch (error) {
        console.error("Error fetching place from lodging selection:", error);
        setPlace(undefined);
      }
    };

    fetchPlace();
  }, [lodgingSelection]);

  return place;
};
